
import { FormCalendar } from "@/app/admin/student/holiday/ui/FormCalendar";
import { DeleteFuntions } from "@/components/funtions/DeleteFuntions";


import './Event.css'
import { FormAddDayAdditional } from "@/app/admin/student/daysadditional/ui/FormAddDayAdditional";

interface Props {
    arg: any,
    funtion: (id: number) => Promise<void>,
    type: string,
    id: string
}

export const EventCalendar = ({ arg, id, type, funtion }: Props) => {

 

    return (
        <div className={`${type === "daysWeek" && !arg.event.title.includes("Extra") ? "event-dayOfWeek" : arg.event.title.includes("Extra") && type === "daysWeek" ? "event-extra" : "event-dayFree"} border-l-[4px] w-full  absolute rounded-md p-5`}>
            <p> <strong>{arg.event.title}</strong></p>
            <p> <strong>{arg.timeText}</strong></p>
            <div className="flex gap-2 absolute bottom-2 right-2">

                {
                    type === "holiday" && (
                        <>

                            <FormCalendar type="edit" id={Number(id)} />
                            <DeleteFuntions id={Number(id)} funtion={funtion} />
                        </>
                    )
                }

                {arg.event.title.includes("Extra") && (
                    <>

                        
                        <DeleteFuntions id={Number(id)} funtion={funtion} />
                    </>
                )}



            </div>
        </div>
    );
}